import { SxStyles } from '../../../../../types';
import theme from '../../../../../theme';
import { getResponsiveSize } from '../../../../../utils';

export const OnlinePanelStyle: SxStyles = {
  onlineContainer: {
    width: '100%',
    padding: 0,
    margin: 0,

    '& .top-tabs_container': {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: getResponsiveSize(30),
      paddingBottom: getResponsiveSize(30),
      borderBottom: `1px solid ${theme.palette.neutral?.grey8}`,
      position: 'relative',

      '& .title': {
        textTransform: 'capitalize',
        fontFamily: theme.typography.mainFontFamily,
        fontSize: getResponsiveSize(16.5),
        minHeight: 0,
        minWidth: 0,
        padding: 0,
        color: '#2392BA',
        fontWeight: '700',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    },

    '& .content-container': {
      height: 'auto',
      maxHeight: getResponsiveSize(350),
      p: getResponsiveSize(25),
      mr: getResponsiveSize(10),
      overflow: 'scroll',
      overflowX: 'hidden',

      '& .audio-type-switch': {
        width: '100%',
        justifyContent: 'space-between',
        pb: getResponsiveSize(15),
        '& .mask-box ': {
          '& .MuiButton-root': {
            '& svg': {
              '&.audio': {
                fill: theme.palette.neutral?.grey50,
              },
              '& .border': {
                stroke: theme.palette.neutral?.grey50,
              },
              '& .play': {
                fill: theme.palette.neutral?.grey50,
              },
            },
            '&.active': {
              color: theme.palette.neutral?.black,
              '& svg': {
                '&.audio': {
                  fill: theme.palette.neutral?.grey70,
                },
                '& .border': {
                  stroke: theme.palette.neutral?.black,
                },
                '& .play': {
                  fill: theme.palette.neutral?.black,
                },
              },
            },
          },
          '& .mask': {
            width: `calc(${theme.palette.propVars?.index} * 4.51)`,
          },
        },
      },
      '&::-webkit-scrollbar': {
        width: 4,
      },
      '&::-webkit-scrollbar-track': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        m: getResponsiveSize(10),
      },
      '&::-webkit-scrollbar-thumb': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        background: theme.palette.neutral?.grey8,
      },
      '& .content-container_back_button': {
        display: 'flex',
        justifyContent: 'flex-start',
      },
    },

    [theme.breakpoints.media?.laptop!]: {
      '& .top-tabs_container': {
        '& .tabs-group': {
          mb: '-2px',
          minHeight: getResponsiveSize(48),
          '& .MuiTabs-scroller': {
            '& .MuiTabs-indicator': {
              bottom: '45%',
            },
          },
        },
      },
    },
  },
};
